import { useCallback } from "react";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { ExistingDummyRoomDefaultUpdateMutation } from "./mutation";
import { viewModelToDummyRoomInputConverter } from "../../_common/view-model-to-dummy-room-input";

import type { ProductDummyRoomFormModel } from "../../../type";

type Props = {
	resetForm: () => void;
};

export const useDummyRoomEditMutation = ({ resetForm }: Props) => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();

	const { mutationFunc } = useCustomMutation(ExistingDummyRoomDefaultUpdateMutation);

	const onUpdate = useCallback(
		async (
			viewModel: ProductDummyRoomFormModel["ViewModel"], //
		) => {
			showLoadingScreenCallback();

			const input = viewModelToDummyRoomInputConverter({ viewModel });

			const { errors } = await mutationFunc({
				variables: {
					input,
				},
			}).finally(hideLoadingScreenCallback);

			if (!errors) {
				notifyUserEventInfo({
					title: "ダミー部屋を更新しました",
				});

				resetForm();
			}
		},
		[hideLoadingScreenCallback, mutationFunc, resetForm, showLoadingScreenCallback],
	);

	return { onUpdate };
};
